





























































import { Component, Vue, Prop } from 'vue-property-decorator'
import Commit from '@/components/comment/index.vue'
import ThumbsUp from '@/components/ThumbsUp/index.vue'
import ReadList from '@/components/ReadList/index.vue'
import { getWeekPlanInfo } from '@/api/week'
import moment from 'moment'

const defaultForm = {}

@Component({
  components: { Commit, ThumbsUp, ReadList },
})
export default class WeekDetail extends Vue {
  formData: any = { ...defaultForm }
  @Prop({ type: String, default: '', required: true })
  planId!: string
   @Prop({ type: String, default: '', required: true })
  commentId!: string
  dataLoading: boolean = true
  moment = moment
  async getDetailById(id: string) {
    const [err, res] = await getWeekPlanInfo(id, {commentId: this.commentId})
    if (err) {
      this.dataLoading = false
      return
    }
    this.formData = res
    this.dataLoading = false
  }
  mounted() {
    this.getDetailById(this.planId)
  }
}
